import { render, staticRenderFns } from "./ClipboardFormFieldIcon.vue?vue&type=template&id=04f06f2d"
import script from "./ClipboardFormFieldIcon.vue?vue&type=script&lang=ts"
export * from "./ClipboardFormFieldIcon.vue?vue&type=script&lang=ts"
import style0 from "./ClipboardFormFieldIcon.vue?vue&type=style&index=0&id=04f06f2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports